import { Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react'
import { UsuariosContext } from '../../pages/catalogos/UsuariosPage';
import { TablaUsuarioComponent } from './TablaUsuarioComponent';
import './TablaUsuariosStyles.css';
export const TablaUsuariosComponent = () => {
    const {usuarioSeleccionado, setUsuarioSeleccionada, obtenerUsuarios, usuarios} = useContext(UsuariosContext)



    useEffect(() => {
        obtenerUsuarios();
    }, [])

    useEffect(() => {
        console.log('usuarios', usuarios);
    }, [usuarios])
        

  return (
    <div
        style={{
            display:'flex',
            flexDirection:'row'
        }}
    >
        <div
            style={{
                display:'flex',
                flexDirection:'column',
                flex:70
            }}
        >
            <div
                style={{
                    display:'flex',
                    flexDirection:'row',
                    backgroundColor:'white',
                    padding:5,
                    borderRadius:20,
                    flex:1,
                    fontWeight:'bold'
                }}
            >
                <Typography style={{fontSize:14, fontWeight:'bold',flex:15}} >Usuario</Typography>
                <Typography style={{fontSize:14, fontWeight:'bold',flex:15}}>Nombre</Typography>
                <Typography style={{fontSize:14, fontWeight:'bold',flex:15}}>Apellido Paterno</Typography>
                <Typography style={{fontSize:14, fontWeight:'bold',flex:15}}>Apellido Materno</Typography>
                <Typography style={{fontSize:14, fontWeight:'bold',flex:15}}>T. Celular</Typography>
                <Typography style={{fontSize:14, fontWeight:'bold',flex:15}}>T. Oficina</Typography>
                <Typography style={{fontSize:14, fontWeight:'bold',flex:15}}>Tipo de Usuario</Typography>
            </div>
            {
                usuarios?.map(usuario=> (
                    <div
                        key={usuario.IdUsuario}
                        style={{
                            display:'flex',
                            flexDirection:'row',
                            backgroundColor:'white',
                            padding:5,
                            borderRadius:20,
                            flex:1,
                            fontWeight:'bold',
                            marginTop:5,
                            alignItems:'center'
                        }}
                    >
                        <TablaUsuarioComponent obtenerUsuarios={obtenerUsuarios} usuario={usuario} />
                    </div>
                ))
            }

        </div>
    </div>
  )
}

const styles = {
    tablaEncabezado: {
        fontSize:14,
        fontWeight:'bold'
    },
    flex15: {
        flex:15
    }
}

